import { useTranslation } from "react-i18next";
import "../../../i18n";
import { Notice } from "../../../design/components";
import { useDocumentQr } from "../../../api/queries";
import styles from "./DocumentInspector.module.css";

export function QrPanel({ docId }: { docId: string }) {
  const { t } = useTranslation();
  const qr = useDocumentQr(docId);

  return (
    <div>
      <h3>{t("documents.inspector.qr.title", "QR information")}</h3>
      {qr.isLoading ? (
        <p className={styles.sub}>{t("documents.inspector.qr.loading", "Loading…")}</p>
      ) : qr.error ? (
        <Notice kind="fail">{t("documents.inspector.qr.loadError", "The QR information could not be loaded.")}</Notice>
      ) : qr.url ? (
        <>
          <img
            className={styles.qr}
            src={qr.url}
            alt={t("documents.inspector.qr.imageAlt", "QR information for this document")}
          />
          <p className={styles.sub}>
            {t(
              "documents.inspector.qr.explainer",
              "Printed on the invoice so the buyer can check the document against the hub record.",
            )}
          </p>
        </>
      ) : (
        <Notice kind="info">{t("documents.inspector.qr.empty", "No QR information for this document")}</Notice>
      )}
    </div>
  );
}
